import React, { useMemo } from 'react';

import { connect } from 'react-redux';

import DealField, { propTypes } from 'bundles/apex/deals/form/fields/field';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';

// Only for custom fields, as those are all that will have options
export function DealSelectField({ changeDeal, deal, invalid, fields, name, label, required }) {
  const options = useMemo(() => {
    return fields[name].options.map(value => ({ label: value, value }));
  }, [fields]);

  return (
    <ManagedFormGroup
      hasError={invalid}
      includeBlank
      label={label}
      name={name}
      required={required}
      type="select"
      value={deal[name]}
      onChange={changeDeal}
    >
      <Options options={options} />
    </ManagedFormGroup>
  );
}

DealSelectField.propTypes = propTypes;

const mapStateToProps = state => ({
  fields: state.fields,
});

export default DealField(connect(mapStateToProps)(DealSelectField));
